<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Tìm kiếm</label>
          <b-input-group>
            <b-form-input
              v-model="localSearchQuery.keyword"
              class="d-inline-block"
              placeholder="Tên xe"
              @keyup.enter="updateSearchQuery"
            />
            <!-- <b-input-group-append>
              <b-button
                variant="primary"
                @click="updateSearchQuery"
              >
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append> -->
          </b-input-group>

        </b-col>
        <b-col
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>Hãng sản xuất</label>
          <v-select
            v-model="localSearchQuery.manufacture_id"
            :options="manufactureData"
            class="w-100"
            :reduce="(val) => val.id"
            label="name"
            placeholder="--Chọn--"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>Trạng thái</label>
          <v-select
            v-model="localSearchQuery.status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="statusOptions"
            class="w-100"
            :reduce="(val) => val.id"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          sm="6"
          class="mb-md-0 mb-2"
        >
          <label>Tình trạng sử dụng</label>
          <v-select
            v-model="localSearchQuery.usageStatus"
            :options="usageStatusOptions"
            class="w-100"
            :reduce="(val) => val.id"
          />
        </b-col>
      </b-row>
      <div class="row mt-1">
        <div class="col-12 col-md-4">

          <b-button
            variant="primary"
            @click="updateSearchQuery"
            @keyup.enter="updateSearchQuery"
          >
            <feather-icon icon="SearchIcon" /> Tìm kiếm
          </b-button>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BInputGroup, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

import { ref } from '@vue/composition-api'
import useMobileVehicle from './useMobileVehicle';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    vSelect,
  },
  props: {
    searchQuery: {
      type: [String, null],
      default: null,
    },
    manufactureData: {
      type: Array,
      default: null,
    },
  },

  setup(props, { emit }) {
    const localSearchQuery = ref({
      manufacture_id: '',
      status: '',
      usageStatus: '',
      keyword: '',
    });
    const { statusOptions, usageStatusOptions } = useMobileVehicle();
    const updateSearchQuery = () => {
      // emit('update:searchQuery', localSearchQuery.value)
      emit('search', localSearchQuery.value);
    }

    return {
      localSearchQuery,
      statusOptions,
      usageStatusOptions,
      updateSearchQuery,
    };
  },

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
